import {MenuItem, TextField} from '@mui/material';

import {BELT_STATUS_OPTIONS} from '../../constants/status';
import {SingleMultiSelectProps} from './SingleMultiSelect';

type Props = Omit<SingleMultiSelectProps, 'options' | 'value'> & {
  value: string;
};

export const BeltStatusSelect = (props: Props) => {
  const statusOptions = BELT_STATUS_OPTIONS.map((o) => ({
    id: o.value,
    name: o.label,
  }));

  const getStatusLabel = (id: string) =>
    statusOptions.find((o) => o.id === id)?.name;

  return (
    <TextField
      {...props}
      label={props.label || 'Belts'}
      value={props.value}
      select
      SelectProps={{
        multiple: false,
        renderValue: (v) => {
          const status = getStatusLabel(v as string);
          return <>Status: {status}</>;
        },
      }}
      onChange={(e) => {
        const v = e.target.value as string;
        props.onChange?.(v);
      }}
    >
      <MenuItem disabled>STATUS</MenuItem>

      {statusOptions.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
};
